import { RouteBase } from "./route-base.model";

export class FtlRoute extends RouteBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected comment: string,
    public blPrice?: number,
  ) {
    super(id, discriminator, comment);
  }

  public getBlPrice(): number {
    return this.blPrice;
  }
  public setBlPrice(param: number) {
    this.blPrice = param;
  }
}
